const VUE_APP_ENV = process.env.VUE_APP_ENV

const DebugUrlObj = {
  baseUrl: 'https://mobilelan.emoney.cn/yktapi',
  h5Url: 'https://mobilelan.emoney.cn/yktstatic'
}

const StagingUrlObj = {
  baseUrl: 'https://yktpre.emoney.cn/yktapi',
  h5Url: 'https://yktpre.emoney.cn/yktstatic'
}

const ReleaseUrlObj = {
  baseUrl: 'https://yktapi.emoney.cn/',
  h5Url: 'https://yktstatic.emoney.cn'
}

const UrlObj =
  VUE_APP_ENV === 'production'
    ? ReleaseUrlObj
    : VUE_APP_ENV === 'staging'
    ? StagingUrlObj
    : VUE_APP_ENV
    ? DebugUrlObj
    : ReleaseUrlObj

export default {
  ...UrlObj
}
